import Vue from 'vue'
import MessageDialog from '@/components/MessageDialog.vue'

const ModalConstructor = Vue.extend(MessageDialog)
let modalInstance

function initModal() {
  modalInstance = new ModalConstructor({
    el: document.createElement('div')
  })
  document.body.appendChild(modalInstance.$el)
}

function showModal(options) {
  if (!modalInstance) {
    initModal()
  }
  Object.assign(modalInstance, options)
  modalInstance.open(options)
}

export default showModal